'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddressesForm = require('./AddressesForm');

Object.keys(_AddressesForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AddressesForm[key];
    }
  });
});

var _CreateAddressForm = require('./CreateAddressForm');

Object.keys(_CreateAddressForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CreateAddressForm[key];
    }
  });
});

var _EditAddressForm = require('./EditAddressForm');

Object.keys(_EditAddressForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EditAddressForm[key];
    }
  });
});